import * as React from 'react';
import * as styles from './styles.css';

interface IPromoMenuProps {
  children: React.ReactNode;
}

export const PromoMenu = React.forwardRef<HTMLDivElement, IPromoMenuProps>(function Component({ children }, ref) {
  return (
    <div ref={ref} className={styles['container']}>
      {children}
    </div>
  );
});
